/*
 * Module for the topic label on the Topic Page.  If there is more than
 * one language in the KB, include an edit button to open a modal to
 * edit the topic label for all languages.  Otherwise allow modification
 * of the label using the Textbox
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicLabel/topicLabelView",
  "modules/topicsSplit/topic/topicLabel/topicLabelModel",
  "modules/topicsSplit/topic/topicLabelModal/topicLabelModalModule",
], function (Marionette, Messenger, TopicLabelView, TopicLabelModel, TopicLabelModalModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicLabel";
    },
    show: function (topicLabels, touchPointLabels, intentId) {
      this.topicLabels = topicLabels;
      //get default language to show
      this.defaultLanguageId = Messenger.reqres.request("default:response:language");
      this.languageList = Messenger.reqres.request("kb:languages"); //get list of languages for the language count
      // (collection may not be synced yet!)
      this.view = new TopicLabelView.topicLabelView({ model: new TopicLabelModel.topicLabel() });

      //select which label to show in the view based on the defaultLanguageId
      topicLabels.onSynced(function () {
        this._setLabel();
      }, this);

      if (!this.languageList.isSynced) {
        //if language list isn't synced, listen for the sync event and re-render the view to handle the edit button
        this.languageList.once(
          "sync",
          function () {
            console.log("language sync");
            this.view.render();
          },
          this,
        );
      }

      //clicked to open editing modal
      this.view.on(
        "edit:label:modal",
        function () {
          Messenger.reqres.request("topic:saveIfNew").then(() => {
            Messenger.vent.trigger(
              "show:modal",
              TopicLabelModalModule,
              {
                intentId: intentId,
                topicLabels: this.topicLabels,
                touchPointLabels: touchPointLabels,
              },
              {},
              {
                title: "topic.label.label",
                closeButton: false,
                closeOnBackgroundClick: false,
                trackInteraction: {
                  action: "Edit Topic Labels",
                  id: intentId,
                  idType: "Topic",
                  object: "Topic",
                },
              },
            );
          });
        },
        this,
      );
      this.showRegion(this.view);
    },
    _setLabel: function () {
      let label = this.topicLabels.findWhere({ languageId: this.defaultLanguageId });
      if (!label) {
        label = this.topicLabels.addLabel(this.defaultLanguageId);
      }
      label.allowEditTopicLabels = Messenger.reqres.request("can:edit:topicLabels");
      label.allowViewTopicLabels = Messenger.reqres.request("can:view:topicLabels");
      label.languageList = this.languageList;
      this.view.model = label;
      this.view.render();
      //since we are assigning the model after initialization, we need to set the view to rerender after a change
      // explicitly
      label.on(
        "change",
        function () {
          this.view.render();
        },
        this,
      );
    },
  });
});
